import {HttpClient} from '@angular/common/http';
import {Component, Input, OnInit, Optional} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SystemService} from '@root/router/system/system.service';
import {RouterService} from '@root/shared/service/router.service';
import {NzDrawerRef} from 'ng-zorro-antd/drawer';

@Component({
  selector: 'host-property-calendar',
  templateUrl: './property-calendar.component.html',
  styleUrls: ['./property-calendar.component.scss'],
})
export class PropertyCalendarComponent implements OnInit {
  @Input() id;

  detail;

  get hasThirdpartyAccount() {
    return this.sysSrv.thirdpartyAccount;
  }

  constructor(
    private route: ActivatedRoute,
    private routerSrv: RouterService,
    private router: Router,
    private sysSrv: SystemService,
    private http: HttpClient,
    @Optional() private drawerRef: NzDrawerRef
  ) {
  }

  ngOnInit() {
    // this.id = this.route.snapshot.paramMap.get('id');
    // const title = this.route.snapshot.queryParamMap.get("title");

    console.log('this.id: ', this.id);

    this.fetchHouseDetail();
  }

  private fetchHouseDetail() {
    const params = {
      house_id: this.id,
    };
    this.http.get('/api/house/details', {params}).subscribe((rst: any) => {
      this.detail = rst?.data;
      const title = this.detail?.house_title;
      // this.routerSrv.updateSingleBreadcrumb(this.router.url, { name: title });
      // console.log('detail: ', this.detail);

      this.drawerRef.nzTitle = title;
    });
  }
}
